/* Action Types */
export const LOAD_LIVE_CATALOG_REGISTRATION_FAIL = 'la/domain/liveCatalogRegistration/LOAD_FAIL';
export const LOAD_LIVE_CATALOG_REGISTRATION_REQUEST = 'la/domain/liveCatalogRegistration/LOAD_REQUEST';
export const LOAD_LIVE_CATALOG_REGISTRATION_SUCCESS = 'la/domain/liveCatalogRegistration/LOAD_SUCCESS';

export const LOAD_UPCOMING_CATALOG_REGISTRATION_FAIL = 'la/domain/upcomingCatalogRegistration/LOAD_FAIL';
export const LOAD_UPCOMING_CATALOG_REGISTRATION_REQUEST = 'la/domain/upcomingCatalogRegistration/LOAD_REQUEST';
export const LOAD_UPCOMING_CATALOG_REGISTRATION_SUCCESS = 'la/domain/upcomingCatalogRegistration/LOAD_SUCCESS';
